export type Locale = 'en' | 'es';

/** English is default at `/` — never use `/en`. Spanish lives at `/es`. */
export function getLocaleFromPathname(pathname: string): Locale {
    if (pathname === '/es' || pathname.startsWith('/es/')) {
        return 'es';
    }
    return 'en';
}

/** Home path for the locale. English stays `/`; Spanish is `/es`. Never `/en`. */
export function localeHomePath(locale: Locale): '/' | '/es' {
    return locale === 'es' ? '/es' : '/';
}
